var IonicRouteStrategy = /** @class */ (function () {
    function IonicRouteStrategy() {
    }
    IonicRouteStrategy.prototype.shouldDetach = function (_route) {
        return false;
    };
    IonicRouteStrategy.prototype.shouldAttach = function (_route) {
        return false;
    };
    IonicRouteStrategy.prototype.store = function (_route, _detachedTree) {
        return;
    };
    IonicRouteStrategy.prototype.retrieve = function (_route) {
        return null;
    };
    IonicRouteStrategy.prototype.shouldReuseRoute = function (future, curr) {
        if (future.routeConfig !== curr.routeConfig) {
            return false;
        }
        if (future.component !== curr.component) {
            return false;
        }
        // checking router params
        var futureParams = future.params;
        var currentParams = curr.params;
        var keysA = Object.keys(futureParams);
        var keysB = Object.keys(currentParams);
        if (keysA.length !== keysB.length) {
            return false;
        }
        // Test for A's keys different from B.
        for (var _i = 0, keysA_1 = keysA; _i < keysA_1.length; _i++) {
            var key = keysA_1[_i];
            if (currentParams[key] !== futureParams[key]) {
                return false;
            }
        }
        return true;
    };
    return IonicRouteStrategy;
}());
export { IonicRouteStrategy };
